import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
import { DynamicObjectInterface } from '../../../sdk/type';
import { UTCToCustomFormat } from '../../../ui/utils';

export const getAuditHistoryLog: GetColumnsType = (
  styles: DynamicObjectInterface,
  translation: DynamicObjectInterface,
  cb: DynamicObjectInterface,
  isAdmin: boolean = false,
) => [
  {
    key: 'createdDate',
    text: translation(isAdmin ? 'admin.auditLog.column.date' : 'dashboard.my-team.column.date'),
    width: 3,
    render: (object: DynamicObjectInterface) => (
      <span>{UTCToCustomFormat(object.createdDate, 'DD/MM/yyyy HH:mm')}</span>
    ),
  },
  {
    key: 'createdBy',
    text: translation(isAdmin ? 'admin.auditLog.column.updatedBy' : 'dashboard.my-team.column.updatedBy'),
    width: 2,
    render: (object: DynamicObjectInterface) => <span>{object.createdBy}</span>,
  },
  {
    key: 'action',
    text: translation(isAdmin ? 'admin.auditLog.column.action' : 'dashboard.my-team.column.action'),
    width: 4,
    render: (object: DynamicObjectInterface) => <span>{object.action}</span>,
  },
];

export const getEmailHistoryLog: GetColumnsType = (
  styles: DynamicObjectInterface,
  translation: DynamicObjectInterface,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'action',
    text: translation('dashboard.my-team.column.recipientEmailAddress'),
    width: 6,
    sortable: true,
    render: (object: DynamicObjectInterface) => <span>{object.action?.split('Send Invitation Email: ')?.[1]}</span>,
  },
  {
    key: 'createdDate',
    text: translation('dashboard.my-team.column.dateTimeSent'),
    sortable: true,
    width: 6,
    render: (object: DynamicObjectInterface) => (
      <span>{UTCToCustomFormat(object.createdDate, 'DD/MM/yyyy HH:mm')}</span>
    ),
  },
];
